export const MinimizeIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 11H18V13H6V11Z" fill="var(--YW_Panels_Subsection_Collapse_Icons_Color)"/>
    </svg>
);


